import './assets/main.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import sessionManager from '@/services/session';
import { initializeToast } from '@/utils/toast';

const app = createApp(App);

// Initialize auth and session manager
store.dispatch('initializeAuth').then(() => {
  // Initialize session manager after auth is loaded
  sessionManager.initialize(store, router);
}).catch(error => {
  console.error('Failed to initialize auth:', error);
  // Still initialize session manager even if auth fails
  sessionManager.initialize(store, router);
});

app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
});

// Initialize toast utility
initializeToast(app);

app.use(router);
app.use(store);
app.mount('#app');